<div class="role-modal-container">
  <div class="role-selection-wrapper">

    <div class="selection-section">
      <div class="header-box">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8px;">
          <div class="mini-badge" style="margin-bottom: 0;">Multi Role Access</div>
        </div>
        <h1 class="welcome-title">Select account</h1>
        <p class="role-subtitle">
          Choose the role you want to use in this session.
        </p>
      </div>

      <!-- <div class="role-list">
        <button
          *ngFor="let role of roles; let i = index"
          class="role-card"
          [class.active]="currentRoleId === role.id"
          [style.--accent-color]="getRoleColor(i)"
          (click)="selectRole(role)"
        > -->
        <div class="role-list">
          <div *ngIf="roles.length === 0" style="padding: 16px; color: #666;">
            No active roles available.
          </div>
        
          <button
            *ngFor="let role of roles; let i = index"
            class="role-card"
            [class.active]="currentRoleId === role.id"
            [style.--accent-color]="getRoleColor(i)"
            (click)="selectRole(role)"
          >
          <div class="role-icon">
            <ion-icon [name]="role.icon || 'person-circle-outline'"></ion-icon>
          </div>

          <div class="role-info">
            <div style="display: flex; align-items: center; gap: 8px;">
              <div class="role-name">{{ role.display_name || role.name }}</div>
              <span class="primary-account-pill" *ngIf="isPrimaryRole(role)">Primary</span>
            </div>
            <div class="role-email">{{ role.description || role.email }}</div>
          </div>

          <div class="role-status" *ngIf="currentRoleId === role.id">Active</div>

          <ion-icon name="chevron-forward-outline" class="role-arrow"></ion-icon>
        </button>
      </div>

    </div>

    <div class="logo-section">
      <div class="logo-wrapper">
        <div class="brand-icon-box">
          <ion-icon name="musical-notes-outline"></ion-icon>
        </div>

        <h3 class="branding-text">PULSE</h3>
        <p class="tagline">Single Login • Multiple Roles</p>

        <div class="brand-points">
          <div class="point-item">
            <ion-icon name="checkmark-circle-outline"></ion-icon>
            <span>Quick role switching</span>
          </div>
          <div class="point-item">
            <ion-icon name="checkmark-circle-outline"></ion-icon>
            <span>No re-login needed</span>
          </div>
          <div class="point-item">
            <ion-icon name="checkmark-circle-outline"></ion-icon>
            <span>Role-based access</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>